export default "__VITE_PUBLIC_ASSET__c8e55f43__"